import { GetApiResponseByUrl } from '@crossbeam/openapi';
import {
  MarkOptional,
  Nullable,
  PrettyPrint,
  StrictOmit,
} from '@crossbeam/types';

import { RoleAccess, UserAccess } from './roles';

export type PartnerUser = {
  id: number;
  first_name: Nullable<string>;
  last_name: Nullable<string>;
  email: string;
  picture_url: Nullable<string>;
  gravatar_url: string;
};

export type PartnersRaw = GetApiResponseByUrl<'/v0.2/partners'>;
export type Partner = PartnersRaw['items'][0];
export type PartnerTrimmed = MarkOptional<Partner, 'tags' | 'users'>;
export type PartnerTagsRaw = GetApiResponseByUrl<'/v0.1/partner-tags'>;
export type PartnerTag = PartnerTagsRaw['items'][0];

export type OverlapCounts =
  GetApiResponseByUrl<'/v0.1/partners/global/overlap-counts'>;

export type OfflinePartner = PrettyPrint<
  StrictOmit<Partner, 'offline_partner'> & {
    offline_partner: true;
  }
>;
export type OfflinePartnerTrimmed = MarkOptional<
  OfflinePartner,
  'tags' | 'users'
>;

export function isOfflinePartner(
  partner: Partner | OfflinePartner,
): partner is OfflinePartner {
  return partner.offline_partner === true;
}

export function isManagedOfflinePartner(
  partner: Partner | ManagedOfflinePartner,
): partner is ManagedOfflinePartner {
  return 'virtual_partner' in partner && partner.virtual_partner === true;
}

export type PartnerTagMap = Record<string, number[]>;

export type PublicInviteOrg = Nullable<{
  name: string;
  logo_url: Nullable<string>;
  clearbit_domain: Nullable<string>;
}>;

export type VisibilityResponse = {
  data: { roles: RoleAccess[]; users: UserAccess[] };
};

export type UpdateVisibilityPayload = {
  users: {
    user_id: number;
    has_access: boolean;
  }[];
  roles: {
    role_id: string;
    has_access: boolean;
  }[];
};

export type ManagedOfflinePartnersResponse =
  GetApiResponseByUrl<'/v0.1/mop/organizations'>;
export type ManagedOfflinePartner = ManagedOfflinePartnersResponse['items'][0];

// export type ManagedOfflinePartnershipsResponse =
//   GetApiResponseByUrl<'/v0.1/mop/partnerships'>;
// export type ManagedOfflinePartnership = ManagedOfflinePartnershipsResponse['items'][0];

export type PartnerMetrics = Partner['metrics'];
export type PartnerScore = NonNullable<PartnerMetrics>['partner_score'];
export type PartnerScoreBucket =
  NonNullable<PartnerMetrics>['partner_score_bucket'];
